module.exports = __webpack_public_path__ + "img/logoKLA.be194869.png";